export default "__VITE_ASSET__xobx0Tnw__"